gsap.registerPlugin(ScrollTrigger);

function initContentRevealScroll(){
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const ctx = gsap.context(() => {

    document.querySelectorAll('[data-reveal-group]').forEach(groupEl => {
      // Skip if already initialized
      if (groupEl.hasAttribute('data-reveal-initialized')) return;
      groupEl.setAttribute('data-reveal-initialized', 'true');

      // Config from attributes or defaults (group-level)
      const groupDistance = groupEl.getAttribute('data-distance') || '2em';
      const triggerStart = groupEl.getAttribute('data-start') || 'top 85%';

      const animDuration = 0.4;
      const animEase = "power4.inOut";

      // Reduced motion: show immediately
      if (prefersReduced) {
        gsap.set(groupEl, { clearProps: 'all', y: 0, autoAlpha: 1 });
        return;
      }

      // Get all direct children
      const directChildren = Array.from(groupEl.children).filter(el => el.nodeType === 1);
      
      if (!directChildren.length) return;

      // Animate each child individually when IT enters viewport
      directChildren.forEach(child => {
        // Skip items that are already animated
        if (child.hasAttribute('data-reveal-done')) return;
        
        // Set initial hidden state
        const distance = child.getAttribute('data-distance') || groupDistance;
        gsap.set(child, { y: distance, autoAlpha: 0 });
        
        // Create individual ScrollTrigger for each child
        ScrollTrigger.create({
          trigger: child,
          start: triggerStart,
          once: true,
          onEnter: () => {
            gsap.to(child, { 
              y: 0, 
              autoAlpha: 1, 
              duration: animDuration, 
              ease: animEase,
              onComplete: () => {
                gsap.set(child, { clearProps: 'all' });
                child.setAttribute('data-reveal-done', 'true');
              }
            });
          }
        });
      });
    });

  });

  return () => ctx.revert();
}

// Initialize Content Reveal on Scroll
let revealCleanup;

function initReveal() {
  if (revealCleanup) revealCleanup();
  revealCleanup = initContentRevealScroll();
  ScrollTrigger.refresh();
}

document.addEventListener("DOMContentLoaded", () => {
  initReveal();
});

// Re-initialize when Shopify loads new content
document.addEventListener("shopify:section:load", () => {
  setTimeout(initReveal, 100);
});

// Listen for new products being added
if (window.addEventListener) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && (node.classList.contains('collection-product-card') || node.tagName === 'LI')) {
            setTimeout(initReveal, 100);
          }
        });
      }
    });
  });

  // Observe the product grid for new products
  const productGrid = document.getElementById('product-grid');
  if (productGrid) {
    observer.observe(productGrid, {
      childList: true,
      subtree: false
    });
  }
}